// extracted by mini-css-extract-plugin
export default {"root":"rf2Ws6JCCtLyd0vbyZ_5","wrap":"zWCrbrDtxTeWAQThMTSi"};